<template>
    <div class="p-3">
        <form-modal
            id="anexo6_2"
            placeholder-button="Inserir" 

            title-modal="Editar baixas"

            :fields="colunas"
            :values="dados"

            ref="modalForm"

            read
            update
            remove

            controles
        >

            <template #table>
                <div>
                        
                    <filtro ref="filtro" @buscar="buscar"/>

                    <div class="table-responsive">
                        <b-table
                        
                            head-variant="dark"
                            :fields="colunas"
                            :items="dados"
                        >
                            
                            <template #cell(obrigacoesSaldoContabil)="data">
                                <div class="d-flex align-items-center">
                                    <span v-if="!data.item.editando">
                                        {{data.value}}
                                    </span>
                                    
                                    <input-money style="width:200px;" v-if="data.item.editando" v-model="form.obrigacoesSaldoContabil"/>
                                    
                                    <b-button v-if="data.item.editando" @click="salvar" variant="flat-success" class="ml-2">
                                        <i class="fas fa-check"></i>
                                    </b-button>
                                    <b-button v-if="data.item.editando" @click="editar(data.item, false)" variant="flat-danger" class="ml-2">
                                        <i class="fas fa-close"></i>
                                    </b-button>
                                    <b-button v-if="!data.item.editando && permissao.u" @click="editar(data.item, true)" variant="flat-primary" class="ml-2">
                                        <i class="fas fa-edit"></i>
                                    </b-button>
                                </div>
                            </template>
                        </b-table>                          
                    </div>  
                </div>
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import {FormMixin} from "@/common/mixins/FormMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Filtro from "../Filtro";
import InputMoney from "@/components/inputs/InputMoney";
import cloneDeep from "lodash.clonedeep";
export default {
    mixins: [AlertasMixin, FormMixin],
    components: {
        FormModal,
        Filtro,
        InputMoney
    },
    props: {
        empresaId: {
            type: String,
            required: true
        },
    },
    data: () => ({
        colunas : [],
        dados : [],        
        form : {},
    }),
    mounted(){
        //this.buscar();
    },
    methods : {
        montar : function(){
            this.inicializarColunas();
            this.$refs['filtro'].montar();
        },
        editar : function(item, editando){
            item.editando = editando;
            if(editando){
                this.form = cloneDeep(item);
                this.form.obrigacoesSaldoContabil = helpers.formatarValor(this.form.obrigacoesSaldoContabil);
            }else{
                this.form = {};
            }
        },
        adicionar : function(){
            this.$refs.modalForm.openModal();
        },
        inicializarColunas : function(){
            this.colunas = [
                {key : "ano", label : "Ano", },
                {key : "mes", label : "Mês", formatter : (valor) => {
                    return valor == "Marco" ? "Março" : valor;
                }},
                {key : "saldoInicial", label : "Saldo inicial da 1104.x", 
                    formatter : (value) => helpers.formatarValor(value || 0), 
                    
                },
                {key : "aplicacoesODS", label : "Aplicações ODS", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
                {key : "baixasProjetosEncerrados", label : "Baixas projetos encerrados", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
                {key : "obrigacoesSaldoContabil", label : "Obrigações saldo contábil", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
                {key : "obrigacoesSaldoAuxiliar", label : "Obrigações saldo auxiliar", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
                {key : "diferenca", label : "Diferença", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
                {key : "saldoFinal", label : "Saldo final da 1104.x", 
                    formatter : (value) => helpers.formatarValor(value || 0)
                },
            ]
        },

        buscar : function(filtro){
            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.listarAnexo6_2(this.empresaId, filtro.ano, filtro.anoFim, filtro.mesInicio, filtro.mesFim).then(response => {
                this.dados = response.data.data.map(el => {
                    el.editando = false;

                    return el;
                });
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        salvar : function(){
            this.confirmar("Aviso", "Deseja salvar saldo contábil").then(confirmado => {
                if(!confirmado)
                    return;

                let form = cloneDeep(this.form);
                form.obrigacoesSaldoContabil = helpers.removerValor(form.obrigacoesSaldoContabil);

                this.$store.dispatch(START_LOADING);
                MovimentacaoFinanceiraService.salvarAnexo6_2(form).then(() => {
                    this.alertaSucesso("Saldo contábil salvo com sucesso!").then(() => {
                        this.$refs['filtro'].buscar();
                    });
                }).catch(() => {
                    this.alertaErro("Erro ao salvar saldo contábil!");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
                
            })
        }
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('MovimentacaoFinanceiraAnexo62');
        }
    }
}
</script>
<style>
    th.colHide {
        display: none;
    }
    .colspan{
        background: #ccc !important;
        color: #666 !important;
        border: 1px solid #666 !important;
        text-align: center !important;
    }
</style>